import {
  useEffect, useRef, MutableRefObject, RefObject,
} from 'react';

function useOuterClick(callback: () => void):RefObject<HTMLDivElement> {
  const innerRef = useRef() as RefObject<HTMLDivElement>;
  const callbackRef = useRef() as MutableRefObject<(e:any) => void>;

  function handleClick(e:any):void {
    if (
      innerRef.current
      && callbackRef.current
      && !innerRef.current.contains(e.target)
    ) {
      callbackRef.current(e);
    }
  }

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return innerRef;
}

export default useOuterClick;
